// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicB2cV2GetAvailableMultiOffersRequest,
  TPublicB2cV2GetAvailableMultiOffersModel,
  IMappers,
  TPublicB2cV2GetAvailableMultiOffersResponse_,
  TPublicB2cV2GetAvailableMultiOffersResponse,
  TPublicB2cV2GetAvailableMultiOffersResponse_1,
  TPublicB2cV2GetAvailableMultiOffersResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createPublicB2cV2GetAvailableMultiOffersModel(
  parameters: TPublicB2cV2GetAvailableMultiOffersRequest,
): TPublicB2cV2GetAvailableMultiOffersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'mortgage-broker-calculator',
    pathApi: '/b2c/v2/get-available-multi-offers/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicB2cV2GetAvailableMultiOffersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicB2cV2GetAvailableMultiOffersRequest;
}

export async function fetchPublicB2cV2GetAvailableMultiOffers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicB2cV2GetAvailableMultiOffersOptions<TResponse200, TResponse400>): Promise<
  TPublicB2cV2GetAvailableMultiOffersResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicB2cV2GetAvailableMultiOffersModel(parameters),
    config,
  )) as FetchResponse<TPublicB2cV2GetAvailableMultiOffersResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicB2cV2GetAvailableMultiOffersResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TPublicB2cV2GetAvailableMultiOffersResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TPublicB2cV2GetAvailableMultiOffersResponse;
}
